import React from "react";
import { BlockLayout } from '../BlockLayout';
import { Carousel } from 'components/Carousel';

export const CarouselBlock = ({ title, files }) => (
    <BlockLayout title={title}>
        <Carousel files={files} />
    </BlockLayout>
)
